import axios from 'axios';
import AppConfig from '../../AppConfig';
import { axiosBaseConfig, setupInterceptors } from './baseAxiosInstance';

const employeeExperienceV1AxiosInstance = axios.create({
  ...axiosBaseConfig,
  baseURL: AppConfig.EMPLOYEE_EXPERIENCE_V1_BASE_URL as string,
});

setupInterceptors(employeeExperienceV1AxiosInstance);

export default employeeExperienceV1AxiosInstance;